import { FC } from "react"

import LoadingIndicator from "./LoadingIndicator"

const FullLoadingPage: FC<{ text?: string }> = ({ text }) => (
	<div className="flex h-screen w-full items-center justify-center">
		<div className="flex flex-col items-center gap-6">
			<LoadingIndicator />
			{text && <p className="text-center text-gray-600">{text}</p>}
		</div>
	</div>
)

export default FullLoadingPage
